import { apiGet, apiPost, apiPut, apiDelete } from "./client.js";

export const listOrgs = () => apiGet("/api/v1/orgs").then((d) => d.organizations || []);
export const getOrg = (id) => apiGet(`/api/v1/orgs/${id}`);
export const createOrg = (data) => apiPost("/api/v1/orgs", data);
export const updateOrg = (id, data) => apiPut(`/api/v1/orgs/${id}`, data);
export const deleteOrg = (id) => apiDelete(`/api/v1/orgs/${id}`);
